let _ = t => t,
  _t;
import { keyframes } from 'styled-components';
import styledWithTheme from 'foundations-theming/utils';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const AnimatedBackground = styledWithTheme.div(_t || (_t = _`
  animation: ${0} 2s ease-in-out infinite;
  height: 100%;
  width: 100%;
`), ({
  theme
}) => keyframes(["0%{background-color:", ";}50%{background-color:", ";}100%{background-color:", ";}"], theme.color['fill-surface-raised'], theme.color['fill-primary-disabled'], theme.color['fill-surface-raised']));
const FileSkeleton = () => /*#__PURE__*/_jsx(View, {
  "data-test-id": "file-skeleton",
  display: "inline-block",
  marginBlockStart: "100",
  blockSize: "34px",
  inlineSize: "100%",
  borderRadius: "100",
  overflow: "hidden",
  children: /*#__PURE__*/_jsx(AnimatedBackground, {})
});
export default FileSkeleton;